import styles from "./index.module.scss";

export default function GoogleMaps({ id, googleMapsType }: { id: string; googleMapsType: string }): JSX.Element {
  let url = `https://www.google.com/maps/embed?pb=${id}`;
  if (googleMapsType === "mid") {
    url = `https://www.google.com/maps/d/embed?mid=${id}`;
  }

  return (
    <div className={styles.googleMapsEmbed__container}>
      <div className={styles.googleMapsEmbed__map}>
        <iframe
          className={styles.googleMapsEmbed__iframe}
          src={url}
          title=""
          allowFullScreen={true}
          referrerPolicy="no-referrer-when-downgrade"
          aria-hidden="false"
          tabIndex={0}
        />
      </div>
    </div>
  );
}
